import { render, staticRenderFns } from "./NewIQCExamine.vue?vue&type=template&id=88c1e7be&scoped=true"
import script from "./NewIQCExamine.vue?vue&type=script&lang=js"
export * from "./NewIQCExamine.vue?vue&type=script&lang=js"
import style0 from "./NewIQCExamine.vue?vue&type=style&index=0&id=88c1e7be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c1e7be",
  null
  
)

export default component.exports